import { Component } from 'preact'
import globals from '../../utils/globals'
import { InstantSearch, Configure } from 'react-instantsearch-dom'
import SuggestedTopicsListContainer from './SuggestedTopicsListContainer'
import CustomSearchBox from './SearchBox'
import algoliasearch from 'algoliasearch/lite'
import { getSearchToken } from '../../services/algoliaService'
import { getFilters } from '@insided/deprecated-preact-components/algolia/components/Search'

class TopicSuggestion extends Component {
  constructor () {
    super()
    this.communityId = globals('communityId')
    this.state = {
      hideSuggestions: true
    }
    this.cb = this.cb.bind(this)
  }

  cb (data) {
    this.setState({
      clientId: data.client_id,
      token: data.token,
      hiddenCategories: data.hiddenCategories
    })
  }

  componentDidMount () {
    getSearchToken(this.cb)
  }

  render () {
    const { clientId, token, hiddenCategories, hideSuggestions } = this.state
    const { searchClient, hosts, defaultCdn } = this.props
    if (!clientId || !token) return null
    return (
      <div className='topic-create_suggestions-wrapper'>
        <InstantSearch
          searchClient={searchClient || algoliasearch(clientId, token, { hosts })}
          indexName={this.communityId}
        >
          <Configure
            hitsPerPage={7}
            analyticsTags={['destination', 'topic creation suggestion']}
            filters={getFilters({ hiddenCategories: hiddenCategories })}
          />
          <CustomSearchBox
            defaultCdn={defaultCdn}
            hideSuggestionsCallback={(value) => this.setState({ hideSuggestions: value })}
          />
          {
            !hideSuggestions && <SuggestedTopicsListContainer />
          }
        </InstantSearch>
      </div>
    )
  }
}

export default TopicSuggestion
